/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntityContextDto
 */
export interface EntityContextDto {
    /**
     * 
     * @type {string}
     * @memberof EntityContextDto
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityContextDto
     */
    firstSeen?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityContextDto
     */
    lastSeen?: string;
}

/**
 * Check if a given object implements the EntityContextDto interface.
 */
export function instanceOfEntityContextDto(value: object): value is EntityContextDto {
    return true;
}

export function EntityContextDtoFromJSON(json: any): EntityContextDto {
    return EntityContextDtoFromJSONTyped(json, false);
}

export function EntityContextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityContextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'] == null ? undefined : json['source'],
        'firstSeen': json['firstSeen'] == null ? undefined : json['firstSeen'],
        'lastSeen': json['lastSeen'] == null ? undefined : json['lastSeen'],
    };
}

export function EntityContextDtoToJSON(json: any): EntityContextDto {
    return EntityContextDtoToJSONTyped(json, false);
}

export function EntityContextDtoToJSONTyped(value?: EntityContextDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'firstSeen': value['firstSeen'],
        'lastSeen': value['lastSeen'],
    };
}

